const Constants = {
  // 字典状态
  DICT_STATUS: {
    '1': '启用, green',
    '2': '停用, red'
  },
  ACCOUNT_STAUS: {
    '0': '已启用',
    '1': '存草稿'
  },
  ACCOUNT_STAUS_LIST: [
    {
      label: '全部',
      value: ''
    },
    {
      label: '已启用',
      value: 0
    },
    {
      label: '存草稿',
      value: 1
    }
  ],
  DICT_STATUS_OPTIONS: [
    {
      label: '全部',
      value: ''
    },
    {
      label: '启用',
      value: 1
    },
    {
      label: '停用',
      value: 2
    }
  ]
}
export default Constants
